import { render, staticRenderFns } from "./TiposContratos.vue?vue&type=template&id=654bf556&scoped=true"
import script from "./TiposContratos.vue?vue&type=script&lang=js"
export * from "./TiposContratos.vue?vue&type=script&lang=js"
import style0 from "./TiposContratos.vue?vue&type=style&index=0&id=654bf556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654bf556",
  null
  
)

export default component.exports